/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GiftAccumulationHistoryModel,
  GiftExchangeHistoryModel,
  GiftExchangeRequestModel,
  ApiResponseModel,
  GiftAccumulationQueryModel,
  GiftListByCustomerModel,
  GiftListByCustomerQueryModel,
  InsertGiftOrderModel,
  GiftOrderRequestModel,
  BaseQuery,
  ListGiftModel,
  GiftOrderModel,
  UpdateGiftOrderRequestModel,
  GiftOrderByCodeModel,
} from "src/types"
import axiosInstance from "./axios"

const getResult = (res: ApiResponseModel<Array<any>>) => {
  return res && res?.Result && Array.isArray(res.Result) && !!res?.Result[0]
    ? (res?.Result[0] as Array<any>)
    : []
}

const giftApis = {
  getGiftExchangeHistory: async (params: GiftExchangeRequestModel) => {
    const response = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      "/getgifttransaction",
      {
        params,
      }
    )
    return getResult(response) as Array<GiftExchangeHistoryModel>
  },
  getGiftAccumulationHistory: async (params: GiftAccumulationQueryModel) => {
    const response = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      "/gettemtransaction",
      { params }
    )

    return getResult(response) as Array<GiftAccumulationHistoryModel>
  },
  getGifts: async (params: BaseQuery) => {
    const response = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      "/listgift",
      { params }
    )

    return getResult(response) as Array<ListGiftModel>
  },
  getGiftsByCustomer: (params: GiftListByCustomerQueryModel) =>
    axiosInstance.get<any, ApiResponseModel<Array<GiftListByCustomerModel>>>(
      "/getlistgiftbycustomer",
      { params }
    ),
  giftExchange: (payload: InsertGiftOrderModel) =>
    axiosInstance.post<any, ApiResponseModel<any>>("/insertgiftorder", payload),
  updateGiftExchange: (payload: UpdateGiftOrderRequestModel) =>
    axiosInstance.post<any, ApiResponseModel<any>>("/updategiftorder", payload),
  getGiftOrder: async (params: GiftOrderRequestModel) => {
    const response = await axiosInstance.get<any, ApiResponseModel<any>>(
      "/getgiforder",
      { params }
    )

    return getResult(response) as Array<GiftOrderModel>
  },

  getGiftOrderByCode: async (redeemcode: string) => {
    const res = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      "api/v1/giftorderbycode",
      {
        params: { redeemcode },
      }
    )
    return res && res.Result && res.Result.length
      ? (res.Result[0] as GiftOrderByCodeModel)
      : undefined
  },
}

export default giftApis
